/* unplugin-vue-components disabled */import { ElDialog as __unplugin_components_11 } from 'element-plus/es';import 'element-plus/es/components/dialog/style/css';
import { ElRow as __unplugin_components_10 } from 'element-plus/es';import 'element-plus/es/components/row/style/css';
import { ElCol as __unplugin_components_9 } from 'element-plus/es';import 'element-plus/es/components/col/style/css';
import { ElInput as __unplugin_components_8 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import { ElTable as __unplugin_components_7 } from 'element-plus/es';import 'element-plus/es/components/table/style/css';
import { ElSwitch as __unplugin_components_6 } from 'element-plus/es';import 'element-plus/es/components/switch/style/css';
import { ElTableColumn as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/table-column/style/css';
import { ElForm as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElButton as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElFormItem as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import { ElSelect as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/select/style/css';
import { ElOption as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/option/style/css';
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1eb8d2a2"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "color": "#3f6df8",
    "font-size": "12px"
  }
}, " *开启浮标之前，请确保【出包】-【渠道配置】-【包名、参数配置】中“ IsShowFloat”为true ", -1));
const _hoisted_2 = {
  class: "dialog-footer"
};
import draggable from 'vuedraggable';
import { useAppStore } from '@/store/modules/app';
import { apiUsdkBuoyConfList, apiUsdkBuoyConfUpdate, apiUsdkGetChannelH5List, apiUsdkGetGameChannel, apiUsdkSwitchConfBatchFobiddenSwitch, apiUsdkSwitchConfGetSwitchList } from '@/api/usdk';
import UUpload from '@ultra/share/components/UUpload/index.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const gameInfo = computed(() => useAppStore().gameInfo);
    const channelList = ref([]);
    const list = ref([]);
    const visible = ref(false);
    const activeItem = ref(null);
    const helpData = ref({
      switch: 0,
      url: '',
      list: []
    });
    // usdk开关相关数据
    const switchData = ref();
    // usdk启用的h5列表
    const h5List = ref([]);
    const cid = ref();
    onMounted(async () => {
      await getSdkChannel();
    });
    const getSdkChannel = async () => {
      let params = {
        gid: gameInfo.value.Id,
        active: 1,
        isHero: 1,
        needIos: 1
      };
      let res = await apiUsdkGetGameChannel(params);
      console.log(res);
      if (res.code !== 0) return;
      channelList.value = res.data;
      cid.value = res.data[0].cid;
      await getList();
    };
    const addHelpItem = () => {
      let obj = {
        name: '',
        btnName: '',
        icon: '',
        webId: null
      };
      helpData.value.list.push(obj);
    };
    const delHelpItem = index => {
      helpData.value.list.splice(index, 1);
    };
    const getList = async () => {
      let params = {
        gid: gameInfo.value.Id,
        cid: cid.value
      };
      let res = await apiUsdkBuoyConfList(params);
      if (res.code != 0) return;
      list.value = res.data;
      getSwitchData();
      await getH5List();
    };
    const getSwitchData = () => {
      apiUsdkSwitchConfGetSwitchList({
        cid: cid.value,
        gid: gameInfo.value && gameInfo.value.Id
      }).then(res => {
        if (res.code != 0) return;
        console.log('switchData---');
        console.log(res.data);
        switchData.value = res.data[0];
        if (switchData.value[`condition_${21}`]) {
          helpData.value = JSON.parse(switchData.value[`condition_${21}`]);
        } else {
          helpData.value = {
            switch: 0,
            list: [],
            url: ''
          };
        }
      });
    };
    const getH5List = async () => {
      let params = {
        cid: cid.value || 0,
        gid: gameInfo.value && gameInfo.value.Id
      };
      const res = await apiUsdkGetChannelH5List(params);
      console.log(res);
      h5List.value = res.data.h5s.filter(item => {
        return (res.data.pids || []).includes(item.id);
      });
    };
    const saveSwitchData = () => {
      let params = {
        gid: gameInfo.value && gameInfo.value.Id,
        cid: switchData.value.cid,
        channel: switchData.value.channel,
        data: []
      };
      helpData.value.list.forEach(item => {
        if (!item.icon) return;
        if (typeof item.icon != 'string') {
          item.icon = item.icon[0].url;
        }
      });
      let emptyList = helpData.value.list.filter(item => {
        return !item.name || !item.webId || !item.icon;
      });
      if (emptyList.length > 0) {
        ElMessage.error('配置项不能为空');
        return;
      }
      if (!helpData.value.url) {
        ElMessage.error('页面地址不能为空');
        return;
      }
      let obj = {
        'type': '21',
        'sw_key': 'sw_buoy_cn_help_center',
        'sw_tip': '',
        'sw_status': '1',
        'id': '',
        'sw_condition': JSON.stringify(helpData.value)
      };
      params.data.push(obj);
      params.data = JSON.stringify(params.data);
      apiUsdkSwitchConfBatchFobiddenSwitch(params).then(res => {
        console.log(res);
        if (res.code != 0) return;
        visible.value = false;
        getList();
      });
    };
    const onShow = item => {
      visible.value = true;
      activeItem.value = item;
    };
    const onSave = async item => {
      let params = {
        prodEnable: item.prodEnable,
        gid: gameInfo.value.Id,
        cid: cid.value,
        giftPkgEnable: 0,
        shareRewardEnable: 0,
        clubEnable: 0,
        wikiEnable: 0,
        recEnable: 0,
        pubEnable: 0
      };
      let res = await apiUsdkBuoyConfUpdate(params);
      if (res.code != 0) return;
      visible.value = false;
      await getList();
    };
    return (_ctx, _cache) => {
      const _component_el_option = __unplugin_components_0;
      const _component_el_select = __unplugin_components_1;
      const _component_el_form_item = __unplugin_components_2;
      const _component_el_button = __unplugin_components_3;
      const _component_el_form = __unplugin_components_4;
      const _component_el_table_column = __unplugin_components_5;
      const _component_el_switch = __unplugin_components_6;
      const _component_el_table = __unplugin_components_7;
      const _component_el_input = __unplugin_components_8;
      const _component_el_col = __unplugin_components_9;
      const _component_el_row = __unplugin_components_10;
      const _component_el_dialog = __unplugin_components_11;
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", null, [_createVNode(_component_el_form, {
        inline: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "选择渠道:"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: _unref(cid),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(cid) ? cid.value = $event : null),
            placeholder: "请选择选择渠道"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(channelList), item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.cid,
                label: item.name,
                value: item.cid
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            onClick: getList
          }, {
            default: _withCtx(() => [_createTextVNode("搜索")]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_hoisted_1]),
          _: 1
        })]),
        _: 1
      })]), _createVNode(_component_el_table, {
        data: _unref(list),
        border: "",
        "row-key": "id"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          label: "联运渠道",
          prop: "cname"
        }), _createVNode(_component_el_table_column, {
          label: "产品ID",
          prop: "productId"
        }), _createVNode(_component_el_table_column, {
          label: "产品名称",
          prop: "productName"
        }), _createVNode(_component_el_table_column, {
          label: "浮标正式开关",
          prop: "prodEnable"
        }, {
          default: _withCtx(({
            row
          }) => [_createVNode(_component_el_switch, {
            modelValue: row.prodEnable,
            "onUpdate:modelValue": $event => row.prodEnable = $event,
            "active-value": 1,
            "inactive-value": 0,
            onChange: $event => onSave(row)
          }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "操作"
        }, {
          default: _withCtx(({
            row
          }) => [_createVNode(_component_el_button, {
            link: "",
            size: "small",
            type: "primary",
            onClick: $event => onShow(row)
          }, {
            default: _withCtx(() => [_createTextVNode("配置帮助中心")]),
            _: 2
          }, 1032, ["onClick"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"]), _createVNode(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _isRef(visible) ? visible.value = $event : null),
        title: "帮助中心配置",
        width: "800px",
        onClose: getList
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_2, [_createVNode(_component_el_button, {
          onClick: _cache[3] || (_cache[3] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: saveSwitchData
        }, {
          default: _withCtx(() => [_createTextVNode(" 保存 ")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, null, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "帮助中心:"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_switch, {
              modelValue: _unref(helpData).switch,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(helpData).switch = $event),
              "active-value": 1,
              "inactive-value": 0
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "页面地址:"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(helpData).url,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(helpData).url = $event),
              placeholder: "请输入页面地址"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createTextVNode("标题名称")]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createTextVNode("ICON")]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createTextVNode("跳转地址")]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 3
          }, {
            default: _withCtx(() => [_createTextVNode("操作")]),
            _: 1
          })]),
          _: 1
        }), _unref(helpData).list.length > 0 ? (_openBlock(), _createBlock(_unref(draggable), {
          key: 0,
          animation: 150,
          list: _unref(helpData).list,
          "no-transition-on-drag": true,
          scrollSensitivity: 200,
          scrollSpeed: 50,
          touchStartThreshold: 10,
          dragClass: "drag-item",
          ghostClass: "ghost-item",
          handle: ".sort-btn",
          "item-key": "index"
        }, {
          item: _withCtx(({
            element,
            index
          }) => [_createVNode(_component_el_row, {
            style: {
              "margin-top": "10px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 5
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: element.name,
                "onUpdate:modelValue": $event => element.name = $event,
                maxlength: "8",
                placeholder: "最多八个字符"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
              _: 2
            }, 1024), _createVNode(_component_el_col, {
              offset: 1,
              span: 5
            }, {
              default: _withCtx(() => [_createVNode(UUpload, {
                modelValue: element.icon,
                "onUpdate:modelValue": $event => element.icon = $event,
                limit: 1,
                "list-type": "picture-card"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
              _: 2
            }, 1024), _createVNode(_component_el_col, {
              offset: 1,
              span: 5
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: element.webId,
                "onUpdate:modelValue": $event => element.webId = $event,
                placeholder: "选择链接"
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(h5List), item => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: item.id,
                    label: `${item.name}-${item.webUrl}`,
                    value: item.webId
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name) + "-" + _toDisplayString(item === null || item === void 0 ? void 0 : item.webUrl), 1)]),
                    _: 2
                  }, 1032, ["label", "value"]);
                }), 128))]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue"])]),
              _: 2
            }, 1024), _createVNode(_component_el_col, {
              offset: 1,
              span: 6
            }, {
              default: _withCtx(() => [_createVNode(_component_el_button, {
                class: "sort-btn",
                plain: "",
                type: "primary"
              }, {
                default: _withCtx(() => [_createTextVNode("排序")]),
                _: 1
              }), _createVNode(_component_el_button, {
                plain: "",
                type: "danger",
                onClick: $event => delHelpItem(index)
              }, {
                default: _withCtx(() => [_createTextVNode("删除")]),
                _: 2
              }, 1032, ["onClick"])]),
              _: 2
            }, 1024)]),
            _: 2
          }, 1024)]),
          _: 1
        }, 8, ["list"])) : _createCommentVNode("", true), _createVNode(_component_el_button, {
          style: {
            "margin-top": "10px"
          },
          type: "primary",
          onClick: addHelpItem
        }, {
          default: _withCtx(() => [_createTextVNode("添加链接")]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
});